import { gql } from '@apollo/client';

export const DEBOUNCE_TIME = 700;

export const ORDER_PROJECTS_BY = 'created_at DESC';
export const PROJECTS_LIMIT = 50;

export const ORDER_COMPANIES_BY = 'name ASC';
export const COMPANIES_LIMIT = 50;

export const ORDER_TEST_SESSIONS_BY = 'created_at DESC';

export const GET_MEETINGS = gql`
  query Meetings($testSessionId: ID!){
    testSession(id: $testSessionId){
      id
      meetingId
    }
    meetings(testSessionId: $testSessionId){
      id
      videoUrl
      duration
      selected
      startedAt
      createdAt
    }
  }
`;

export const GET_ALL_COMPANIES = gql`
  query Companies($limit: Int!, $offset: Int!, $order: String!, $search: String) {
    companies(limit: $limit, offset: $offset, order: $order, search: $search) {
      id
      name
    }
  }
`;

export const GET_PROJECTS_BY_COMPANY = gql`
  query Projects($companyId: ID!, $limit: Int!, $offset: Int!, $order: String!, $name: String) {
    projects(companyId: $companyId, limit: $limit, offset: $offset, order: $order, name: $name) {
      id
      name
    }
  }
`;

export const GET_TEST_SESSIONS_BY_PROJECT = gql`
  query TestSessions(
    $projectId: ID!,
    $order: String!
  ) {
    testSessions(
     projectId: $projectId, order: $order
    ) {
      id
      meetingId
      tester {
        id
        user {
          id
          profile {
            id
            firstName
            lastName
          }
        }
      }
    }
  }
`;

export const SELECT_AND_PROCESS_MUTATION = gql`
  mutation SelectAndProcessMeeting($testSessionId: ID!, $meetingId: ID!) {
        selectAndProcessMeeting(testSessionId: $testSessionId, meetingId: $meetingId){
            meeting{
              id
            }
        }
      }
`;
